
































































































































































import { Component } from "vue-property-decorator";
import { VFields } from "@/models/v-fields";
import { Base } from "@/components/common/base";
import { storeService } from "@/shared";
import { vehicleInventoryService } from "@/shared";
import { PaginationModel, VHeaders } from "@/models/pagedlistmodel";
import { mapGetters } from "vuex";

@Component({
    props: ["methodName", "progress"],

    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
        ...mapGetters({ sourceStoreName: "getStoreName" }),
    },
    components: {
        Stores: () => import("@/components/common/store.select.vue"),
        Grid: () => import("@/components/common/app.grid.vue"),
        AppDialog: () => import("@/components/common/app.dialog.vue"),
    },
})
export default class VehicleWholeSaleTransferPage extends Base {

    public selectedStore: any = "";
    public selectedSaleType: any = null;
    public currentUserStoreId: number = 1;

    public stores: any[] = [];
    public loading: boolean = false;
    public journalAccountingTransactionList: any[] = [];
    public inboundAccountingTransactionList: any[] = [];
    public saleLoading: boolean = false;
    public inboundStoreList: any;
    public saleType: any[] = [];
    public showStore: boolean = false;
    public inboundList: any[];
    public vehicleLookupCost: string;
    public franchiseStores: any[] = [];
    public selectedFranchiseStore: any = "";
    public selectedFranchiseStoreDeatails: any;
    public vehicleSaleAccount: any;
    public vehicleReceivableAccount: string;
    public vehicleSalePayableAccount: string;
    public listItemId: string;
    public sourceStoreName: string;
    public inboundStoreName: string;
    public inboundVehicleDmsUpdateStatus: boolean = false;
    public inboundVehicleDmsUpdateMessage: string = "";
    public sourceVehicleDmsAddStatus: boolean = false;
    public sourceVehicleDmsAddMessage: string = "";
    public menu: boolean = false;
    public vehicleDetailsLoading: boolean = false;
    public created(): void {
        this.currentUserStoreId = this.userSession.storeId;
    }

    public pagination = new PaginationModel("date", true);

    public beforeDestroy() {
        const buttons = [];
        this.$emit("updateToolBar", buttons);
    }

    public callMethod(methodName): void {
        if (methodName === "backToList") {
            this.$router
                .push({
                    name: "app.vehiclewholesale",
                })
                .catch((ex) => {
                    console.log(ex);
                });
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== "") {
            this.$emit("resetMethodName", methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({
            id: "0",
            type: "button",
            title: this.$parent.$t("stores.btnBackToStoreTitle"),
            visible: true,
            class: "btn",
            label: this.$parent.$t("stores.btnBack"),
            click: "backToList",
            icon: "fas fa-arrow-left",
        });
        this.$emit("updateToolBar", buttons);
    }

    public mounted() {
        // Toolbar
        this.updateToolBar();
        this.$watch("methodtoCall", (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });

        this.listItemId = this.$route.params.id;
        this.loading = true;
        this.vehicleDetailsLoading = true;
        this.saleLoading = true;
        this.getStores();
        this.fetchInboundList();

    }

    public vehicleWholesaleTransferColumns: VHeaders[] = [
        {
            text: "Journal",
            align: "center",
            value: "Journal",
            sortable: false,
        },
        {
            text: "Account",
            align: "center",
            value: "Account",
            sortable: false,
        },
        {
            text: "Description",
            align: "center",
            value: "Description",
            sortable: false,
        },

        {
            text: "Date ",
            align: "center",
            value: "Date",
            sortable: false,
        },
        {
            text: "Control Number",
            align: "center",
            value: "ControlNumber",
            sortable: false,
        },
        {
            text: "Amount ",
            align: "center",
            value: "Amount",
            sortable: false,
        },
        {
            text: "Posting Detail",
            align: "center",
            fieldType: 'template',
            template: (item) => {
                if (item.isPosted == true) {
                    return '<span class= "green kbd px-1"> Posted </span>';
                } else {
                    return '<span class= "red kbd px-1"> Failed </span>';
                }
            },
            sortable: false,
        },
        {
            text: "Posting Message ",
            align: "center",
            value: "errorMessage",
            sortable: false,
        },
    ];

    public vehicleInboundColumns: VHeaders[] = [
        {
            text: "Journal",
            align: "center",
            value: "Journal",
            sortable: false,
        },
        {
            text: "Account",
            align: "center",
            value: "Account",
            sortable: false,
        },
        {
            text: "Description",
            align: "center",
            value: "Description",
            sortable: false,
        },

        {
            text: "Date ",
            align: "center",
            value: "Date",
            sortable: false,
        },
        {
            text: "Control",
            align: "center",
            value: "ControlNumber",
            sortable: false,
        },
        {
            text: "Amount ",
            align: "center",
            value: "Amount",
            sortable: false,
        },
        {
            text: "Posting Detail",
            align: "center",
            fieldType: 'template',
            template: (item) => {
                if (item.isPosted == true) {
                    return '<span class= "green kbd px-1"> Posted </span>';
                } else {
                    return '<span class= "red kbd px-1"> Failed </span>';
                }
            },
            sortable: false,
        },
        {
            text: "Posting Message ",
            align: "center",
            value: "errorMessage",
            sortable: false,
        },
    ];

    public vehicleWholeSaleTransferFormModel = {
        stockNumber: "",
        make: "",
        model: "",
        vin: "",
        vehicleCost: "",
        saleAmount: "",
        date: "",
    };

    public async getStores(): Promise<void> {
        try {

            const response = await storeService.getStoresList();

            var indexToRemove = response.results.findIndex(
                (item) => item.id == this.currentUserStoreId.toString()
            );
            if (indexToRemove !== -1) {
                response.results.splice(indexToRemove, 1);
            }
            this.stores = response.results;

        } catch (ex) {
            console.log(ex);

        }
    }



    public async GetVehicleSaleGroupAccountsByStoreId(
        selectedStoreId
    ): Promise<void> {
        try {


            const response =
                await vehicleInventoryService.GetVehicleSaleGroupAccountsByStoreId(
                    Number(selectedStoreId)
                );

            let res = this.stores.filter((store) => store.id == this.selectedStore);
            this.inboundStoreName = res[0].dealershipName;

            let data = response.vehicleSaleGroup;
            if (data && data.length > 0) {
                data.forEach((franchise) => {
                    franchise.franchiseDescription =
                        franchise.franchiseCode + " - " + franchise.franchiseDescription;
                });
            }
            this.franchiseStores = data;

        } catch (ex) {
            console.log(ex);

        }
        finally {
            this.setViewFeilds();
            this.loading = false;
        }
    }


    public async fetchInboundList() {

        try {

            this.inboundStoreList =
                await vehicleInventoryService.getVehicleTransferDetailById(
                    this.listItemId
                );
            if (this.inboundStoreList) {
                this.setViewFeilds();
                this.vehicleDetailsLoading = false;
                this.saleLoading = false;
                this.GetVehicleSaleGroupAccountsByStoreId(Number(this.selectedStore));
            }
        } catch (ex) {
            console.log(ex);

        }


    }

    public setViewFeilds() {
        this.inboundAccountingTransactionList = [];
        this.journalAccountingTransactionList = [];
        this.vehicleWholeSaleTransferFormModel.stockNumber =
            this.inboundStoreList.vehicleDetails.stockNumber;
        this.vehicleWholeSaleTransferFormModel.model =
            this.inboundStoreList.vehicleDetails.model;
        this.vehicleWholeSaleTransferFormModel.make =
            this.inboundStoreList.vehicleDetails.make;
        this.vehicleWholeSaleTransferFormModel.saleAmount =
            this.inboundStoreList.saleAmount;
        this.vehicleWholeSaleTransferFormModel.vin =
            this.inboundStoreList.vehicleDetails.vin;
        this.vehicleWholeSaleTransferFormModel.date =
            this.inboundStoreList.transactionDate;
        this.vehicleWholeSaleTransferFormModel.vehicleCost =
            this.inboundStoreList.vehicleDetails.vehicleCost;
        this.selectedStore = this.inboundStoreList.inboundStoreId;
        this.selectedFranchiseStore =
            this.inboundStoreList.vehicleSaleGroup.franchiseCode;
        if (this.inboundStoreList.vehicleSaleAccountSetup) {

            this.saleType.push(this.inboundStoreList.vehicleSaleAccountSetup);
            this.vehicleReceivableAccount =
                this.inboundStoreList.vehicleReceivableAccount;
            this.vehicleSalePayableAccount =
                this.inboundStoreList.vehicleSalePayableAccount;
        }

        this.sourceVehicleDmsAddStatus = this.inboundStoreList.vehicleDetails.isPosted;
        this.inboundVehicleDmsUpdateStatus = this.inboundStoreList.isVehicleUpdated;
        this.inboundVehicleDmsUpdateMessage = this.inboundStoreList.vehicleUpdatedErrorMessage;
        this.sourceVehicleDmsAddMessage = this.inboundStoreList.vehicleDetails.errorMessage;

        this.selectedSaleType = this.inboundStoreList.vehicleSaleAccountSetup.id;
        this.selectedStore = this.inboundStoreList.inboundStoreId;
        this.inboundStoreList.sourceStoreAccountingDetail.forEach((item) => {
            this.journalAccountingTransactionList.push({
                Account: item.account ?? "N/A",
                Description: item.description ?? "N/A",
                Date: item.date ?? "N/A",
                ControlNumber: item.controlNumber ?? "N/A",
                Amount: item.amount,
                Journal: "VSU",
                isPosted: item.isPosted,
                errorMessage: item.errorMessage ?? "N/A"
            });
        });

        this.inboundStoreList.inboundStoreAccountingDetail.forEach((item) => {
            this.inboundAccountingTransactionList.push({
                Account: item.account ?? "N/A",
                Description: item.description ?? "N/A",
                Date: item.date ?? "N/A",
                ControlNumber: item.controlNumber ?? "N/A",
                Amount: item.amount ?? "N/A",
                Journal: item.journal ?? "N/A",
                isPosted: item.isPosted,
                errorMessage: item.errorMessage ?? "N/A"
            });
        });




    }
}
